import { inject, injectable } from 'inversify'
import Debug from 'debug';
import * as Api from '@xlearn/common';
import { PlayerModule } from '../api'
import {
  CourseCompletionService, CourseCompletionServiceSymbol,
  CourseCompletionSettings
} from './service/course-completion-service';

const debug = Debug('course-completion-player-module')

@injectable()
export class CourseCompletionPlayerModule implements PlayerModule {

  readonly name = 'course-completion'

  constructor(
    @inject(CourseCompletionServiceSymbol)
    private courseCompletionService: CourseCompletionService) {
  }

  start(instance: Api.SerializedAspectInstance): void {
    const settings = this.parseSettings(instance.details.courseCompletion)
    debug('start', instance, settings)
    this.courseCompletionService.updateSettings(settings)
  }

  reset(instance: Api.SerializedAspectInstance): void {
    const settings = this.parseSettings(instance.details.courseCompletion)
    debug('reset', instance, settings)
    this.courseCompletionService.updateSettings(settings)
  }

  async stop() {
  }

  private parseSettings(input: Api.SerializedCourseCompletionInfo): CourseCompletionSettings {
    switch (input.completionMode) {
      case 'final-exam':
        return { mode: 'final-exam' as const }
      case 'section-percentage':

        if (input.passingSectionPercentage === undefined) {
          throw new Error('Coding error: missing section percentage')
        }

        return {
          mode: 'section-percentage' as const,
          passingSectionPercentage: input.passingSectionPercentage
        }
      case 'none':
        return { mode: 'none' as const }
    }
  }
}
